module.exports = __webpack_public_path__ + "img/yingyong_icon03.4103fd14.png";